import { render, staticRenderFns } from "./InstanceShareItem.vue?vue&type=template&id=594aa46e&scoped=true"
import script from "./InstanceShareItem.vue?vue&type=script&lang=js"
export * from "./InstanceShareItem.vue?vue&type=script&lang=js"
import style0 from "./InstanceShareItem.vue?vue&type=style&index=0&id=594aa46e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594aa46e",
  null
  
)

export default component.exports